
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  height: 100%;
  text-align: center;
}

.idb-highlights-card {
  height: 100%;
  border-radius: 0.5rem;
  background-color: var(--blue-responsible-lighten-4);
  text-align: center;
  color: var(--blue-responsible-darken-2);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 768px) {

  .idb-highlights-card {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
}

@media (min-width: 1280px) {

  .idb-highlights-card {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .idb-highlights-card {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

@media (min-width: 1440px) {

  .idb-highlights-card {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .idb-highlights-card {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.idb-highlights-card{
  word-break:break-word;
}

.inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#heading {
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  font-weight: var(--fw-bold);
  text-transform: uppercase;
}

@media (min-width: 768px) {

  #heading {
    color: var(--gray-professional-lighten-1);
  }
}

#heading {
  margin-bottom: 0.25rem;
}

@media (min-width: 768px) {

  #heading {
    margin-bottom: 1.25rem;
  }
}

@media (min-width: 1280px) {

  #heading {
    margin-bottom: 0.75rem;
  }
}

@media (min-width: 1440px) {

  #heading {
    margin-bottom: 1.25rem;
  }
}

#info {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}

@media (min-width: 768px) {

  #info {
    font-size: var(--fs-xl);
    line-height: var(--lh-xl);
  }
}

@media (min-width: 1280px) {

  #info {
    font-size: var(--fs-base);
    line-height: var(--lh-base);
  }
}

@media (min-width: 1440px) {

  #info {
    font-size: var(--fs-xl);
    line-height: var(--lh-xl);
  }
}

@media (min-width: 768px) {

  #info {
    font-weight: var(--fw-semibold);
  }

  #info {
    color: var(--blue-responsible-main);
  }
}
`;